import React, {useState, useContext} from 'react';
import { CircularProgress, Avatar, Button, CssBaseline, TextField, Link, Box, Typography, Container } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import bg_image from '../asset/adventist-symbol-tm--white.png';
import { API } from '../conf';
import { TokenContext } from '../App';
import { Buffer } from 'buffer';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="http://www.feam.org/">
        FEAM
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


export default function SignIn() {
  const [loading, setLoad] = useState(false)
  const [msg, setMsg] = useState()
  const [token, setToken] = useContext(TokenContext)

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const mail = data.get('email')
    const mdp = data.get('password')

    if (mail.length > 0 && mdp.length > 0) {
      setLoad(true)
      fetch(API.concat('/super_admin/login'), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+Buffer.from(mail+':'+mdp).toString('base64'),
        },
    })
    .then(async(response)=> {
      if(response.status === 200 && response.headers.get('x-auth-token'))  {
        setToken(response.headers.get('x-auth-token')); 
        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
      }
      else if(response.status === 401)  {
        const text = await response.text()
        setMsg(text)
        setLoad(false)
      }
    })
    
    }
  };

  return (
    <div style={{position:'absolute', right:0, left:0, top:0, bottom:0, backgroundColor: "rgba(121, 225, 213, 0.45)", display:'flex', flexDirection:'column', justifyContent:'center'}}>
      <div style={{position:'absolute', right:0, left:0, top:0, bottom:0, display:'flex', justifyContent:'center', alignItems:'center'}}>
        <img src={bg_image} alt={'logo église adventiste'} style={{height:'100%', opacity:0.25, marginTop:-30}} loading="lazy" />
      </div>

      <Typography color={'white'} variant='h3' align='center' marginTop={-25}>Système de gestion des congés FEAM</Typography>
		  
      <Container component="main" maxWidth="xs" >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: '#51B2A7' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Connexion
          </Typography>
          <Typography><span style={{color: 'coral', fontSize:14}}>{msg}</span></Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              color='verdigris'
              required
              fullWidth
              id="email"
              label="Identifiant"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              color='verdigris'
              required
              fullWidth
              name="password"
              label="Mot de passe"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              color="verdigris"
              disabled={loading}
            >
              {loading && <CircularProgress size={18} color='verdigris' style={{marginRight:7}}/> } Connexion
            </Button>
          </Box>
        </Box>
      </Container>
      <div style={{position:'absolute', bottom:0, display:'flex', width:'100%', justifyContent:'center'}}><Copyright sx={{ mt: 8, mb: 4 }} style={{bottom:0}} /></div>
    </div>
  );
}